import { Box, Card, Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreCustomer, type CoreInsurance } from '@flecto/types'
import {
  BadgeCustomerVerification,
  DataTable,
  type DataTableColumn,
} from '@flecto/ui/@shared'

import { TextCustomerContacts } from '../../../customers'

export function CustomerDetails({ insurance }: { insurance: CoreInsurance }) {
  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })

  const columns: DataTableColumn<CoreCustomer>[] = [
    {
      accessor: 'full_name',
      width: 250,
      title: t('insurances_details.label_customer_name'),
      render: (row) => <Text>{row.full_name ?? '-'}</Text>,
    },
    {
      accessor: 'contacts',
      title: t('insurances_details.label_customer_contacts'),
      render: (row) => <TextCustomerContacts customer={row} />,
    },
    {
      accessor: 'vat_number',
      title: t('insurances_details.label_customer_vat_number'),
      render: (row) => <Text>{row.vat_number ?? '-'}</Text>,
    },
    {
      accessor: 'identification',
      title: t('insurances_details.label_customer_identification'),
      render: (row) => <BadgeCustomerVerification customer={row} />,
    },
  ]

  return (
    <Card>
      <Flex align='center' justify='space-between' mb='lg'>
        <Box style={{ flex: 1 }}>
          <Text fw={500}>{t('insurances_details.label_customer')}</Text>
          <Text c='dimmed' size='sm'>
            {t('insurances_details.card_customer_description')}
          </Text>
        </Box>
      </Flex>

      <DataTable
        withBorder={false}
        columns={columns}
        records={insurance?.customer ? [insurance?.customer] : []}
      />
    </Card>
  )
}
